import {Button, Checkbox, Form} from "antd";
import React, {ReactNode} from 'react';
import arrowBack from "../../../../assets/images/arrow-left.svg";
import {FormValuesAcceptance} from "../../../../core/models/custom/formValuesAcceptance";
import {OfferValue} from "../../../../core/models/custom/offerValue";
import FirebaseService from "../../../../core/services/firebaseService/firebase.service";
import FirebaseKey from "../../../FirebaseKey/FirebaseKey";
import "./AcceptanceForm.scss";

interface IProps {
  isNewcomer: boolean;
  isBuyForHumpDisabled: boolean;
  isTurkcell: boolean;
  offer: OfferValue;
  isLoading: boolean;
  callbackApproval: (values?: FormValuesAcceptance) => void;
}

enum FieldNames {
  saveCard = 'saveCard',
}

const AcceptanceForm = (props: IProps) => {
  const [form] = Form.useForm();
  
  function handleFinish(values: FormValuesAcceptance): void {
    FirebaseService.logEvent(FirebaseService.getContinue(props.offer.id));
    props.callbackApproval({
      saveCard: values.saveCard ?? false,
      etk: false, // etk field cancelled.
      contract: true, // contract field cancelled.
    });
  }
  
  function getButtonText(): string {
    if (props.isTurkcell && !props.isBuyForHumpDisabled) {
      return 'KREDİ KARTI İLE DEVAM ET';
    }
    return props.isNewcomer ? 'KAZAN' : 'DEVAM ET';
  }
  
  function renderCheckBoxes(): ReactNode {
    return (
      <div className="checkbox-wrapper">
        <div onClick={() => form.setFieldsValue({saveCard: !form.getFieldValue(FieldNames.saveCard)})}>
          <FirebaseKey className="checkbox-text" firebaseKey={FirebaseService.cc_save_card_text}/>
        </div>
        <Form.Item
          name={FieldNames.saveCard}
          valuePropName="checked"
          initialValue={true}
        >
          <Checkbox defaultChecked/>
        </Form.Item>
      </div>
    );
  }
  
  return (
    <Form
      form={form}
      id="acceptance-form"
      onFinish={handleFinish}
    >
      {renderCheckBoxes()}
      <div className="buttons">
        {
          props.isNewcomer &&
          <Button
            className="app-button secondary"
            disabled={props.isLoading}
            onClick={() => props.callbackApproval()}
          >
            <img src={arrowBack} alt="arrow"/>
          </Button>
        }
        <Button
          className="app-button"
          htmlType="submit"
          disabled={props.isLoading}
        >
          {getButtonText()}
        </Button>
      </div>
    </Form>
  );
}

export default AcceptanceForm;
